import { ResponseError } from '../General';
export enum IMAGE_TYPE {
  NONE = '0',
  LOGO = '1',
  SITE_PLAN = '2',
  COMPANY_BUILDING = '4',
  CONTACT = '7',
  FREETEXT = '46',
  MAP_ICON = '13',
  LIST_LOGO = '20',
  LIST_ICON = '21',
  LIST_PICTURE = '41',
  HEAD = '40',
  GALLERY_PICTURE = '42',
  PARTNER_PICTURE = '51',
  PROMO_PICTURE = '52',
  VIDEO = '53',
  POWER_LISTING_LOGO = '54',
  PRODUCT = '55'
}

export enum IMAGE_FORMAT {
  NONE = '0',
  GIF = '1',
  JPG = '2',
  PNG = '3',
  JPEG = '4'
}

export enum MEMO_TYPE {
  NONE,
  BUSINESS,
  CONTACT_INFO,
  CUSTOM,
  CUSTOM_2,
  CUSTOM_3,
  CUSTOM_4,
  CUSTOM_TAB_TITLE,
  EXPIRY_DATE,
  METADESCCRIPTION,
  MOVIES,
  OPENING_DATE,
  OPENING_HOURS,
  OPENING_HOURS_2,
  OPENING_HOURS_SEARCHABLE,
  PICTURE_CAPTION,
  PICTURE_CAPTION_2,
  PICTURE_LOGO_CAPTION,
  PROFILES,
  SMART_BIT,
  SMART_PUMP,
  SPECIALS,
  TIMEZONEID,
  TRANSPORT_CONNECTION,
  VIDEO,
  WELCOME,
  YELP_ID,
  PAYMENT_OPTIONS,
  SPECIAL_OFFER,
  LISTS,
  CLOSED_DATE,
  URL,
  SPECIALITIES,
  BRANDS,
  PRODUCTS,
  SERVICES,
  YEAR_ESTABLISHED,
  ASSOCIATIONS,
  LANGUAGES,
  OPENING_HOURS_ADDITION,
  IMPRESSUMLINK,
  IMPRESSUMTEXT,
  TRACKING,
  TMP_FREETEXT,
  TMP_FREETEXT1,
  TMP_FREETEXT2,
  TMP_FREETEXT3,
  TMP_FREETEXT4,
  TMP_FREETEXT5,
  OFFSET_TIME,
  OFFSET_TIME_SUMMER,
  JSON_INFO,
  BUSINESS_VIEW,
  ADDITIONAL_CONTACT_INFO
}

export enum OPENING_HOURS {
  NONE,
  MASK_1,
  MASK_2,
  MASK_3,
  MASK_4
}

export enum OBJECT_LIST_TYPE {
  NONE = 'NONE',
  PRODUCTS = 'PRODUCTS',
  LINKS = 'LINKS',
  NEWS = 'NEWS',
  CUSTOM = 'CUSTOM',
  HOME = 'HOME',
  CONTACT = 'CONTACT',
  CHAPTER = 'CHAPTER',
  FREETEXT = 'FREETEXT',
  PRINT = 'PRINT',
  PARTNERS = 'PARTNERS',
  PROMOTIONS = 'PROMOTIONS',
  VIDEOS = 'VIDEOS',
  COUPONS = 'COUPONS',
  INFOTEXT = 'INFOTEXT'
}

export interface GeoItem {
  Country: string;
  District: string;
  Zip: string;
  City: string;
  CityAddOn: string;
  CityPart: string;
  Street: string;
  HouseNo: string;
  GeoLevel: string;
  CityLevel: string;
  SeoLink: string;
  DistrictID: string;
  Description: string;
  LocX: string;
  LocY: string;
  CoordFormat: string;
}

export interface Paging {
  Page: number;
  MaxPage: number;
  Count: number;
  MaxCount: number;
}

export interface Identifiers {
  YMID: string;
  YMID3: string;
  YMIDUrlEncoded: string;
  YMIDPathEncoded: string;
  YMIDDecoded: string;
  ProviderID: string;
  ProviderForeignKey: string;
  ProviderEnum: string;
}

export interface BranchListElement {
  BranchCode: string;
  BranchText: string;
  Keywords: string;
  Frequency: string;
  MarketPlace: string;
  MarketNumber: string;
  SortNr: number;
  Country: string;
  Language: string;
  BranchCodePredecessor: string;
  NoOfBranchCodeChilds: number;
}

export interface HtmlImage {
  Url: string;
  Link: string;
  Width: number;
  Height: number;
  AltText: string;
  Name: string;
}

export interface YellowMapsImage {
  HtmlImage: HtmlImage;
  ImageID: string;
  Type: IMAGE_TYPE;
  Format: IMAGE_FORMAT;
  Country: string;
  Language: string;
  Caption: string;
}

export interface MemoItem {
  Type: MEMO_TYPE;
  OpeningHoursMask: OPENING_HOURS;
  Title: string;
  Text: string;
  BlockNo: number;
  OpeningHoursMondayTilFridayFrom: string;
  OpeningHoursMondayTilFridayUntil: string;
  OpeningHoursMondayFrom: string;
  OpeningHoursMondayUntil: string;
  OpeningHoursMondayMorningFrom: string;
  OpeningHoursMondayMorningUntil: string;
  OpeningHoursMondayAfternoonFrom: string;
  OpeningHoursMondayAfternoonUntil: string;
  OpeningHoursTuesdayFrom: string;
  OpeningHoursTuesdayUntil: string;
  OpeningHoursTuesdayMorningFrom: string;
  OpeningHoursTuesdayMorningUntil: string;
  OpeningHoursTuesdayAfternoonFrom: string;
  OpeningHoursTuesdayAfternoonUntil: string;
  OpeningHoursWednesdayFrom: string;
  OpeningHoursWednesdayUntil: string;
  OpeningHoursWednesdayMorningFrom: string;
  OpeningHoursWednesdayMorningUntil: string;
  OpeningHoursWednesdayAfternoonFrom: string;
  OpeningHoursWednesdayAfternoonUntil: string;
  OpeningHoursThursdayFrom: string;
  OpeningHoursThursdayUntil: string;
  OpeningHoursThursdayMorningFrom: string;
  OpeningHoursThursdayMorningUntil: string;
  OpeningHoursThursdayAfternoonFrom: string;
  OpeningHoursThursdayAfternoonUntil: string;
  OpeningHoursFridayFrom: string;
  OpeningHoursFridayUntil: string;
  OpeningHoursFridayMorningFrom: string;
  OpeningHoursFridayMorningUntil: string;
  OpeningHoursFridayAfternoonFrom: string;
  OpeningHoursFridayAfternoonUntil: string;
  OpeningHoursSaturdayFrom: string;
  OpeningHoursSaturdayUntil: string;
  OpeningHoursSaturdayMorningFrom: string;
  OpeningHoursSaturdayMorningUntil: string;
  OpeningHoursSaturdayAfternoonFrom: string;
  OpeningHoursSaturdayAfternoonUntil: string;
  OpeningHoursLongSaturdayFrom: string;
  OpeningHoursLongSaturdayUntil: string;
  OpeningHoursSundayFrom: string;
  OpeningHoursSundayUntil: string;
  OpeningHoursSundayMorningFrom: string;
  OpeningHoursSundayMorningUntil: string;
  OpeningHoursSundayAfternoonFrom: string;
  OpeningHoursSundayAfternoonUntil: string;
}

export interface ObjectListItem {
  Type: OBJECT_LIST_TYPE;
  ID: string;
  ListNo: string;
  SortNo: string;
  XCoord: string;
  YCoord: string;
  Country: string;
  Language: string;
  CreateDate: string;
  DateFrom: string;
  DateUntil: string;
  Editor: string;
  Headline: string;
  SubHeadline: string;
  Description: string;
  LongText: string;
  Surname: string;
  Firstname: string;
  Phone: string;
  Fax: string;
  Email: string;
  Url: string;
  Category: string;
  SubCategory: string;
  Department: string;
  Manufacturer: string;
  Price: string;
  PartnerCategoriesID: string;
  Image: YellowMapsImage;
}

export interface YellowMapsAddress {
  FirstName: string;
  CompanyName: string;
  CompanyNameAddon1: string;
  CompanyNameAddon2: string;
  CompanyNameAddon3: string;
  Country: string;
  Zip: string;
  City: string;
  CityPart: string;
  Street: string;
  HouseNo: string;
  Postbox: string;
}

export interface Contact {
  Phone: string;
  Mobile: string;
  Fax: string;
  Email: string;
  Url: string;
  Url2: string;
  Url3: string;
}

export interface Geo {
  XCoord: string;
  YCoord: string;
  GeocodeStatus: string;
  Distance: string;
  MatrixRouteDistance: string;
  MatrixRouteTime: string;
  DistanceToRoute: string;
}

export interface BasicData {
  Identifiers: Identifiers;
  BranchListElements: BranchListElement[];
  Images: YellowMapsImage[];
  MemoItems: MemoItem[];
  ObjectListItems: ObjectListItem[];
  Address: YellowMapsAddress;
  Contact: Contact;
  Geo: Geo;
}

export interface AddressItem {
  BasicData: BasicData;
}

export interface SearchData {
  NewSearchOnRectChange: boolean;
  Catchwords: string;
  Branches: string;
  Location: { XCoord: string; YCoord: string };
}

export interface AddressTile {
  ClusterID: string;
  XFocus: string;
  YFocus: string;
  Count: number;
  ProductTypes: string;
  ProductCategory: string;
}

export interface AddressSearchResult extends ResponseError {
  GeoItems: GeoItem[];
  Paging: Paging;
  AddressItems: AddressItem[];
  AddressTiles: AddressTile[];
  RelatedBranches: BranchListElement[];
  SearchData: SearchData;
}
